import { ArrowDown } from "lucide-react";
import { useEffect, useState } from "react";
import HeroPhone from "./HeroPhone";
import "./hero.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Hero({ count }) {
  const [videoUrl, setVideoUrl] = useState(null);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    fetch(`${BACKEND_URL}/api/hero/video`)
      .then((r) => r.json())
      .then((d) => d.url && setVideoUrl(`${BACKEND_URL}${d.url}`))
      .catch(() => {});
  }, []);
  return (
    <section className="lp-dark" data-testid="hero" style={{ position: "relative", minHeight: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <img className="lp-hero-img" src={`${BACKEND_URL}/api/files/hero_frame_wide.png`} alt="" />
      {videoUrl && (
        <video className={`lp-hero-video${ready ? " in" : ""}`} data-testid="hero-video"
               autoPlay muted loop playsInline preload="auto" onPlaying={() => setReady(true)}>
          <source src={videoUrl.replace(".mp4", ".webm")} type="video/webm" />
          <source src={videoUrl} type="video/mp4" />
        </video>
      )}
      <div className="lp-hero-veil" style={{ zIndex: 1 }} />
      <div className="lp-grain" aria-hidden="true" />
      <HeroPhone />
      <nav className="lp-nav" style={{ position: "relative", zIndex: 4, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "36px 64px" }}>
        <span className="wordmark" data-testid="nav-wordmark" style={{ fontSize: 40, color: "var(--porcelain)" }}>marova</span>
        <div style={{ display: "flex", gap: 32, alignItems: "center" }}>
          <a href="#how" data-testid="nav-how">How it works</a>
          <a href="#business" data-testid="nav-business">For businesses</a>
          <a href="#waitlist" data-testid="nav-waitlist" className="btn" style={{ borderColor: "var(--porcelain)", color: "var(--porcelain)" }}>Join the waitlist</a>
        </div>
      </nav>
      <div className="lp-hero-copy" style={{ position: "relative", zIndex: 4, padding: "40px 64px 96px", maxWidth: 820, marginTop: "auto", marginBottom: "auto" }}>
        <div className="eyebrow fade-up" style={{ color: "var(--blush)" }}>Launching first in San Diego · 2026</div>
        <h1 className="serif fade-up" style={{ fontSize: "clamp(56px, 8vw, 120px)", fontWeight: 500, lineHeight: .95, margin: "22px 0 0", letterSpacing: "-0.015em", animationDelay: "80ms" }}>
          Your evening,<br /><em style={{ color: "var(--blush)" }}>handled.</em>
        </h1>
        <p className="fade-up" style={{ fontSize: 19, lineHeight: 1.6, color: "rgba(251,248,247,.78)", maxWidth: 520, marginTop: 32, animationDelay: "160ms" }}>
          One request. Every service. Confirmed — without seven apps and a phone call. Marova sends what you need straight to the spa, and they plan it around you.
        </p>
        <div className="fade-up" style={{ display: "flex", alignItems: "center", gap: 20, marginTop: 44, animationDelay: "240ms" }}>
          <a href="#waitlist" data-testid="hero-cta" className="btn btn-primary" style={{ padding: "16px 28px", fontSize: 14 }}>Join the waitlist <ArrowDown size={14} /></a>
        </div>
      </div>
    </section>
  );
}
